import { render, staticRenderFns } from "./list-item-especie-avis.vue?vue&type=template&id=7bafbe6f"
import script from "./list-item-especie-avis.vue?vue&type=script&lang=js"
export * from "./list-item-especie-avis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports